import React, {useEffect, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {useGetSinks} from "../../api/get-sinks";
import {NumberBox} from "devextreme-react/number-box";
import {SelectedMaterial} from "../../types/SelectedMaterial";
import {CheckBox} from 'devextreme-react/check-box';
import Validator from "devextreme-react/validator";
import {RequiredRule} from "devextreme-react/form";
import {useGetSinkLabor} from "../../api/get-sink-labor";

export function SinksColumnControl({group}: { group: SelectedMaterial }) {
    const context = useCountertops();
    const sinks = useGetSinks(context.dealerId, group.prodQteGrpID ?? 0, context.customerZip);
    const sinkLabor = useGetSinkLabor(context.dealerId, group.prodQteGrpID ?? 0, -1, context.customerZip);
    const [selectedSinks, setSelectedSinks] = useState<Map<number, number | undefined>>(new Map<number, number | undefined>());
    const [checkedState, setCheckedState] = useState<Map<number, boolean>>(new Map<number, boolean>());

    useEffect(() => {
        let map = new Map<number, number | undefined>();
        let checkedMap = new Map<number, boolean>();
        group.sinks.forEach(item => {
            map.set(item.productID, item.qty);
            checkedMap.set(item.productID, true);
        });

        setSelectedSinks(map);
        setCheckedState(checkedMap);
    }, [group.sinks])

    if (sinks.isLoading || sinkLabor.isLoading)
        return <></>

    return (
        <>
            <p className={"group-name"}>{group.name}</p>
            <table className={'split-column'}>
                <tbody>
                {sinks.data.map(sink =>
                    <tr key={sink.productID}>
                        <td style={{width: '30px', textAlign: "center"}}>
                            <CheckBox
                                value={checkedState.get(sink.productID) ?? false}
                                onValueChanged={(e) => {
                                    if (e.event) {
                                        if (e.value) {
                                            context.updateSink(group.prodQteGrpID, sink.productID, undefined, sinkLabor.data?.productID ?? undefined);
                                        } else {
                                            context.removeSink(group.prodQteGrpID, sink.productID);
                                        }
                                    }
                                }}
                            />
                        </td>
                        <td>
                            {sink.name}
                        </td>
                        <td style={{width: '30px'}}>
                            {sink.thickness}
                        </td>
                        <td style={{whiteSpace: 'nowrap'}}>
                            {sink.dimensions}
                        </td>
                        <td>
                            <img src={sink.imageUrl} style={{maxWidth: '30px'}}/>
                        </td>
                        <td style={{width: '62px'}}>
                            <NumberBox
                                min={1}
                                style={{width: '60px'}}
                                showSpinButtons={true}
                                value={selectedSinks.get(sink.productID)}
                                disabled={!(checkedState.get(sink.productID) ?? false)}
                                valueChangeEvent='blur'
                                format={'fixedPoint'}
                                onValueChanged={(e) => {
                                    if (e.event) {
                                        context.updateSink(group.prodQteGrpID, sink.productID, e.value ?? undefined, sinkLabor.data?.productID ?? undefined)
                                    }
                                }}

                            >
                                <Validator>
                                    <RequiredRule message={"Quantity must be set and greater than 0"}></RequiredRule>
                                </Validator>
                            </NumberBox>
                        </td>
                        <td style={{width: '42px'}}>
                            {sink.uom}
                        </td>

                    </tr>
                )}
                </tbody>
            </table>
        </>
    );
}
